"use client"

import * as React from "react"
import { Switch as SwitchPrimitive } from "radix-ui"

import { cn } from "@/custolink-newdesign/lib/utils"

function Switch({
  className,
  size = "default",
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: "sm" | "default"
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        "cl:peer cl:group/switch cl:inline-flex cl:shrink-0 cl:items-center cl:rounded-full cl:border cl:border-transparent cl:shadow-xs cl:transition-all cl:outline-none cl:focus-visible:border-ring cl:focus-visible:ring-[3px] cl:focus-visible:ring-ring/50 cl:disabled:cursor-not-allowed cl:disabled:opacity-50 cl:data-[size=default]:h-[1.15rem] cl:data-[size=default]:w-8 cl:data-[size=sm]:h-3.5 cl:data-[size=sm]:w-6 cl:data-[state=checked]:bg-primary cl:data-[state=unchecked]:bg-input cl:dark:data-[state=unchecked]:bg-input/80",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "cl:pointer-events-none cl:block cl:rounded-full cl:bg-background cl:ring-0 cl:transition-transform cl:group-data-[size=default]/switch:size-4 cl:group-data-[size=sm]/switch:size-3 cl:data-[state=checked]:translate-x-[calc(100%-2px)] cl:data-[state=unchecked]:translate-x-0 cl:dark:data-[state=checked]:bg-primary-foreground cl:dark:data-[state=unchecked]:bg-foreground"
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
